import { graphql } from "@/gql";

export const supplierNameQuery = graphql(`
  query SupplierName($id: ID!) {
    supplier(id: $id) {
      id
      name
    }
  }
`);
